import { render, staticRenderFns } from "./TitleEl.vue?vue&type=template&id=f86e85c0&scoped=true&"
import script from "./TitleEl.vue?vue&type=script&lang=ts&"
export * from "./TitleEl.vue?vue&type=script&lang=ts&"
import style0 from "./TitleEl.vue?vue&type=style&index=0&id=f86e85c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86e85c0",
  null
  
)

export default component.exports